import { render, staticRenderFns } from "./CaseOfficeInsurance.vue?vue&type=template&id=4bc27bb2"
import script from "./CaseOfficeInsurance.vue?vue&type=script&lang=js"
export * from "./CaseOfficeInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports